module.exports = __webpack_public_path__ + "img/xsbjl.ca2a39fb.jpg";